import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SpinnerModule } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { GenLoadingSpinnerService } from 'src/app/generac/services/loading-spinner.service';

@Component({
  selector: 'gen-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  imports: [CommonModule, SpinnerModule]
})
export class GenLoadingSpinnerComponent implements OnInit {
  showSpinner$: Observable<boolean>;

  constructor(
    protected genLoadingSpinnerService: GenLoadingSpinnerService
  ) { }

  ngOnInit(): void {
    this.showSpinner$ = this.genLoadingSpinnerService.getSpinnerState();
  }
}
